import React, { useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import Close from "../../../../assets/icon/svg/close";
import { formatTimeTxt } from "../../../../services/helpers/Helper";
import { deletePostCampaign } from "../../../../store/action/campaignsAction";
import Modal from "../../../shared/components/modal";
import Posts from "./posts";

const ListPosts = (props) => {
   const { page, campaign, deletePostCampaign } = props;
   const { posts } = campaign;
   const params = useParams();
   const { id } = params;
   const [isShowPost, setIsShowPost] = useState(false);
   const [isShowConfirm, setIsShowConfirm] = useState(false);
   const [idSelected, setIdSelected] = useState(0);

   const handleConfirmDelete = (id) => {
      setIsShowConfirm(true);
      setIdSelected(id);
   }

   const handleCancelConfirm = () => {
      setIsShowConfirm(false);
      setIdSelected(0);
   }

   const handleDelete = () => {
      deletePostCampaign(idSelected, id);
      handleCancelConfirm()
   }

   const getListIdSelected = () => {
      return posts.map((m) => m.post_id);
   }

   const getPicture = (item) => {
      return item.post_picture;

   }

   return (
      <React.Fragment>
         <div className="card-sale-post selected-post">
            <div className="title-container">
               <div className="title">
                  <div className="svg-next-icon mr4 icon-news-post">
                  </div>
                  <span>Bài viết</span>
               </div>
               {posts.length > 0 &&
                  <button type="button" className="app-btn app-btn-primary mr8 button-select-post" onClick={() => setIsShowPost(true)}>Chọn bài viết</button>
               }
            </div>
            {posts.length > 0 ?
               <React.Fragment>
                  {posts.map((item, index) => {
                     return (
                        <div className="auto-comment-post-item sale-post display-flex align-items-center justify-content-space-between line-height-20" key={index}>
                           <div className="display-flex align-items-center" >
                              <div className="auto-comment-post-item__thumb mr8">
                                 {getPicture(item)
                                    ?
                                    <img src={getPicture(item)} />
                                    :
                                    <div className="default-thumb d-flex-center">
                                       <div className="svg-next-icon image-default-v2">
                                       </div>
                                    </div>
                                 }
                              </div>
                              <div className="auto-comment-post-item__description post-item">
                                 <div className="auto-comment-post-item__description-content text-ellipsis">
                                    <span title={item.post_name}>{item.post_name}</span>
                                 </div>
                                 <div className="text-ellipsis font-size-12">
                                    <div className="hover-to-copy-wrapper">
                                       <div className="hover-to-copy-container">
                                          <div className="title-copy-to-clipboard child">
                                             Post ID : {item.post_id}
                                             <div className="svg-next-icon button-copy-to-clipboard icon-copy-fill">
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="auto-comment-post-item__description-info font-size-12 display-flex">
                                    <div><span className="capitalize-first-letter">
                                       {formatTimeTxt(new Date(item.created_at).getTime())}
                                    </span>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div className="auto-comment-post-item">
                              <a className=" link-post pointer" href={`https://www.facebook.com/${item.post_id}`} target="_blank">
                                 <div className="svg-next-icon mr4 mb1 icon-link ic_link" >
                                 </div>
                                 <span className="content">Đến bài viết gốc</span>
                              </a>
                              <button type="button" className="app-btn app-btn-default delete-post ml24" onClick={() => handleConfirmDelete(item.post_id)}>
                                 <div className="svg-next-icon icon mr4 mb1 ic-recycle-bin-two-lines-new">
                                 </div>
                                 <span>Xóa</span>
                              </button>
                           </div>
                        </div>
                     )
                  })}
               </React.Fragment>
               :
               <div className="select-post-action">
                  <button type="button" className="app-btn app-btn-primary mr8 button-select-post" onClick={() => setIsShowPost(true)}>
                     Chọn bài viết
                  </button>
                  <span>
                     Hoặc đăng tin mới trên trang facebook
                     <a href={`https://www.facebook.com/${page.social_id}`} className="app-btn app-btn-link app-btn-pd-none v-a-base" target="_blank">
                        tại đây
                     </a>
                  </span>
               </div>
            }
         </div>
         {isShowPost && <Posts onClose={() => setIsShowPost(false)} listIdSelected={getListIdSelected()} />}
         {isShowConfirm &&
            <Modal>
               <div className="modal-dialog app-modal auto-comment-list-delete modal-sm" role="document">
                  <div className="modal-content">
                     <div className="app-modal-header">
                        <h4 className="app-modal-title">
                           <div><span>Bạn có thật sự muốn xóa bài viết này?</span></div>
                        </h4>
                        <span className="app-close" onClick={handleCancelConfirm}>
                           <Close />
                        </span>
                     </div>
                     <div className="app-modal-bodyapp-modal-body-pd-0"></div>
                     <div className="app-modal-footer">
                        <div className="col-auto">
                           <div className="modal-delete-footer">
                              <button type="button" className="app-btn app-btn-default" onClick={handleCancelConfirm}>
                                 <span><div className="svg-next-icon ic_close"></div></span>
                                 <span className="mt2">Hủy</span>
                              </button>
                              <button type="button" className="app-btn app-btn-danger" onClick={handleDelete}>
                                 <span><div className="svg-next-icon ic-recycle-bin-two-lines"></div></span>
                                 <span className="mt2">Xóa</span>
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </Modal>
         }
      </React.Fragment>
   )
}


const mapStateToProps = (state) => {
   const { page, campaign } = state;

   return {
      campaign,
      page,
   };
};


export default connect(mapStateToProps, {
   deletePostCampaign
})(ListPosts);